// pmDirectoryClient — AUTHENTICATED staff client for the PM Company Directory
// CRUD (Phase 4). Uses the shared `api` helper (Bearer token + 401 refresh-
// retry). Mirrors PmDirectoryRecord in apps/api/src/lib/pmDirectory.ts and the
// route shapes in apps/api/src/routes/rentalVerificationsReview.ts.

import { api } from './api';

export interface PmDirectoryRecord {
  pmId: string;
  companyName: string;
  aliases?: string[];
  domains: string[];
  phones?: string[];
  overrideEmail: string;
  active: boolean;
  isWelcomeHome?: boolean;
  owner?: string;
  verificationMethod?: string;
  lastVerifiedAt?: string;
  staleAfter?: string;
  createdAt: string;
  createdByDisplay: string;
  updatedAt: string;
  updatedByDisplay: string;
}

/** Fields a staff user can create. */
export interface PmDirectoryCreate {
  companyName: string;
  overrideEmail: string;
  domains: string[];
  aliases?: string[];
  phones?: string[];
  active?: boolean;
  isWelcomeHome?: boolean;
  owner?: string;
  verificationMethod?: string;
  staleAfter?: string;
}

/** Partial update — only the present keys change. */
export type PmDirectoryPatch = Partial<Omit<PmDirectoryCreate, 'domains'>> & {
  domains?: string[];
};

export async function listPmDirectory(): Promise<PmDirectoryRecord[]> {
  const r = await api.get<{ entries: PmDirectoryRecord[] }>('/api/pm-directory');
  return r.entries;
}

export async function createPmEntry(body: PmDirectoryCreate): Promise<PmDirectoryRecord> {
  const r = await api.post<{ entry: PmDirectoryRecord }>('/api/pm-directory', body);
  return r.entry;
}

export async function updatePmEntry(
  pmId: string,
  patch: PmDirectoryPatch,
): Promise<PmDirectoryRecord> {
  const r = await api.patch<{ entry: PmDirectoryRecord }>(
    `/api/pm-directory/${encodeURIComponent(pmId)}`,
    patch,
  );
  return r.entry;
}

export async function deletePmEntry(pmId: string): Promise<void> {
  await api.del<{ ok: true }>(`/api/pm-directory/${encodeURIComponent(pmId)}`);
}
